/*eslint complexity: off*/
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import MonetizationOn from '@material-ui/icons/MonetizationOn';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';

import Paper from '~/components/Paper';
import ChipItem from '~/components/Chip';
import GridItem from '~/components/GridItem';
import InputShow from '~/components/InputShow';
import ModalDelete from '~/components/ModalDelete';
import PaperButtons from '~/components/PaperButtons';
import GridContainer from '~/components/GridContainer';

import Request from '~/providers/Request';
import PackRecord from '~/records/PackRecord';
import { AbilityContext } from '~/contexts/Can';
import { historyPropType } from '~/config/routerPropTypes';
import { packs, createPack, editPack } from '~/config/routes';
import { packagesColors, packageOptions } from '~/config/constants';

import Context from './context';

const attrName = (attr) => PackRecord.hummanAttributeName(attr);

function ShowPack({ history }) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [record, setRecord] = useState(new PackRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if (records && records[id]) {
      setRecord(record.updateAttributes(records[id]));
    }
    setLoading(true);
    Request.get(`/admin/packs/${id}`, {})
      .then((response) => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord(record.updateAttributes(response.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete() {
    setLoading(true);
    Request.del(`/admin/packs/${id}`)
      .then(() => {
        toast.success(t('delete-toast-success'));
        history.push(packs.spec);
      })
      .catch(() => {
        setLoading(false);
        toast.error(t('delete-toast-fail'));
      });
    setModal(false);
  }

  return (
    <Paper
      Icon={MonetizationOn}
      iconColor="blue"
      title={t('packs.defSingular')}
      loading={loading}
      actions={
        <PaperButtons
          id={id}
          setModal={ability.can('delete', 'Packs') ? setModal : null}
          backRoute={packs}
          newRoute={ability.can('new', 'Packs') ? createPack : null}
          editRoute={ability.can('edit', 'Packs') ? editPack : null}
        />
      }
    >
      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
          <InputShow label={attrName('name')} value={record.get('name')} />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <InputShow
            label={attrName('description')}
            value={record.get('description')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <InputLabel shrink>{attrName('packages')}</InputLabel>
          <br />

          {record.get('pack_packages') &&
            record
              .get('pack_packages')
              .filter((item) => item.specialty_id === null)
              .map((item, index) => (
                <ChipItem
                  key={index}
                  label={packageOptions[item.pack_type]}
                  colorHex={packagesColors[item.pack_type]}
                />
              ))}

          {record.get('pack_packages') &&
            record
              .get('pack_packages')
              .filter((item) => item.specialty_id === null).length <= 0 && (
              <Chip
                label={t('packs.extras.noPackages')}
                variant="outlined"
                color="secondary"
              />
            )}
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <InputLabel shrink>{attrName('specialties')}</InputLabel>
          <br />

          {record.get('pack_packages') &&
            record
              .get('pack_packages')
              .filter((item) => item.specialty_id !== null)
              .map((item, index) => (
                <ChipItem
                  key={index}
                  label={item.specialty.name}
                  color="primary"
                />
              ))}

          {record.get('pack_packages') &&
            record
              .get('pack_packages')
              .filter((item) => item.specialty_id !== null).length <= 0 && (
              <Chip
                label={t('packs.extras.noSpecialties')}
                variant="outlined"
                color="secondary"
              />
            )}
        </GridItem>
      </GridContainer>

      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
        }}
        name={record.get('name')}
        id={record.get('id')}
        deleteAction={handleDelete}
      />
    </Paper>
  );
}

ShowPack.propTypes = {
  history: historyPropType,
};

export default ShowPack;
